<template>
  <v-layout row justify-center>
    <CModal :show.sync="dialog" :title="dialogTitle" max-width="500px" scrollable
            hide-footer>
        <v-progress-linear v-if="processing" :style="{ margin: 0 }" :indeterminate="true"></v-progress-linear>
        <v-container fill-height fluid :class="$style['card-container']">
          <v-layout nowrap>
            <v-flex>
              <v-card outlined :class="$style['card-content']">
                <v-card-text :class="$style['card-text']">
                  <form>
                    <p>サンプル依頼に応じてテンプレートメッセージの自動返信を行う機能</p>
                    <div style="font-weight:bold;">●テンプレートメッセージ</div>
                    <div :class="$style['dialog-content']">
                      <div :class="$style['dialog-content-title']">サンプル依頼受領時</div>
                      <div>- ユーザーよりサンプルの依頼を受けた際</div>
                    </div>
                    <div :class="$style['dialog-content']">
                      <div :class="$style['dialog-content-title']">出荷完了時</div>
                      <div>- 依頼商品のサンプルを出荷した際</div>
                    </div>
                    <div :class="$style['dialog-content']">
                      <div :class="$style['dialog-content-title']">サンプル発送不可時</div>
                      <div>- 依頼商品のサンプル発送の対応が難しい際</div>
                    </div>
                    <div :class="$style['dialog-content']">
                      <div :class="$style['dialog-content-title']">レビュー受領時</div>
                      <div>- ユーザーよりレビューの受領があった際</div>
                    </div>
                  </form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

      <template #footer>
        <CSwitch
                color="primary"
                :checked="onRequestFromAppStatus"
                value="primary"
                @update:checked="onChangeRequestFromAppStatus"
                labelOn="on" labelOff="off"
        />
      </template>
    </CModal>
  </v-layout>
</template>

<script>
  import utility from "@/utility";
export default {
  props: {
    resourceName: {
      type: String
    }
  },
  data() {
    return {
      checked: false
    };
  },
  watch: {
    dialog(show) {
      const vm = this;
      if (!show) {
        this.$store.commit(this.resourceName + "/list/initialize");
        this.$store.dispatch(`${this.resourceName}/list/fetchAutoReplySetting`, {});
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.getters[this.resourceName + "/list/open"];
      },
      set(value) {
        this.$store.commit(this.resourceName + "/list/close");
      }
    },
    onRequestFromAppStatus: {
      get() {
        return this.$store.getters[this.resourceName + "/list/onRequestFromAppValid"] === 1;
      },
      set(value) {
        this.$store.commit(this.resourceName + "/list/updateonRequestFromAppValid", {
          onRequestFromAppValid: value ? 1 : 0
        });
      }
    },
    processing() {
      return this.$store.getters[this.resourceName + "/list/processing"];
    },
    dialogTitle() {
      return "自動返信設定";
    }
  },
  methods: {
    async submit() {
      this.$store
        .dispatch(this.resourceName + "/list/setAutoReplySetting", {})
        .then(() => {
          this.$message({
            message: "設定更新が完了しました。",
            type: "success"
          });
        });
    },
    onChangeRequestFromAppStatus(value){
      this.onRequestFromAppStatus = value;
      this.submit();
    }
  },
  mounted() {
    this.$store.dispatch(`${this.resourceName}/list/fetchAutoReplySetting`, {});
  }
};
</script>

<style module lang="scss">
.card-container {
  padding: 0px !important;
  border-bottom: 1px solid #eee;
}
.card-text {
  padding: 0px !important;
}
.card-content {
  height: 280px;
  overflow-y: auto;
  padding: 8px 0 !important;
  border: none !important;
}
.error-messages {
  margin: 0;
  margin-top: 8px !important;
  padding-left: 46px !important;
  & > li {
    list-style-type: none;
    min-height: 23px;
    line-height: 12px;
    font-size: 12px;
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
  }
}
.reset-dialog-btn {
  & > span {
    font-size: 14px !important;
  }
}

.dialog-content {
  padding-bottom: 5px;
}

.dialog-content-title {
  text-decoration: underline;
}
</style>
<style lang="scss">
.v-card__title {
  font-size: 14px !important;
}
</style>
